import GradientBorderRadius from "@/ui/gradient-border-radius";
import TransactionsHeader from "./transactions-header";
import { TransactionsFilterProvider } from "@/providers/transactions-filter/transactions-filter";
import TransactionsBotTable from "./transactions-bot-table";

const Transactions = ({
  expanded,
  toggleExpanded,
}: {
  expanded?: boolean;
  toggleExpanded?: () => void;
}) => {
  return (
    <TransactionsFilterProvider>
      <GradientBorderRadius overflow className="h-full">
        <div className="h-full px-0.5">
          <TransactionsHeader
            expanded={expanded}
            toggleExpanded={toggleExpanded}
          />
          <TransactionsBotTable />
        </div>
      </GradientBorderRadius>
    </TransactionsFilterProvider>
  );
};

export default Transactions;
